export const TRIGGERED_ALERTS_SEARCH_PARAMS = "open=true&silenced=true&notTriggered=false"
export const ALL_ALERTS_SEARCH_PARAMS = "open=true&silenced=true&notTriggered=true"
